<template lang="pug">
  div
    el-row(type='flex')
      el-col(:span="8").container-input
        app-label(label="Nome do documento:", :required="false")
        el-input.input(
          v-model="filtro.nome"
          @blur="whitespace('nome')"
        )
      el-col(:span="8").container-input
        app-label(label="Responsável:", :required="false")
        el-select.input#responsavel(
          class="select",
          v-model="filtro.responsavel",
          placeholder="Selecione",
          value-key="id"
          clearable
        )
          el-option(
            v-for="item in responsavelList",
            :key="item.id",
            :label="item.usuario.pessoa.nomeRazaoSocial",
            :value="item"
          )
      el-col(:span="8").container-input
        app-label(label="Tipo do documento:", :required="false")
        el-select.input#documento(
          class="select",
          v-model="filtro.tipoDocumento",
          placeholder="Selecione",
          value-key="id"
          clearable
        )
          el-option(
            v-for="item in documentoList",
            :key="item.id",
            :label="item.nome",
            :value="item"
          )

    el-row(type='flex')
      el-col(:span="8")
        app-label(label="Data de envio:", :required="false")
        el-date-picker#periodoAssinatura(
          v-model="filtro.dataEnvio"
          type="daterange"
          unlink-panels
          range-separator="até"
          start-placeholder="Início"
          end-placeholder="Fim"
          format="dd/MM/yyyy"
          :picker-options="pickerOptions"
        )
      el-col(:span="8")
        app-label(label="Ativo:", :required="false")
        el-switch#ativo(
          v-model="filtro.ativo"
          active-color="#13ce66"
          active-text="Sim"
          inactive-text="Não"
        )

</template>

<script>
import AppLabel from '@/components/AppLabel'
import { mapActions } from 'vuex'

const UMA_SEMANA = new Date().getTime() - 3600 * 1000 * 24 * 7
const UM_MES = new Date().getTime() - 3600 * 1000 * 24 * 30
const TRES_MESES = new Date().getTime() - 3600 * 1000 * 24 * 90

export default {
  components: {
    AppLabel
  },

  props: {
    filtro: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      responsavelList: [],
      estadoDemandaList: [],
      documentoList: [],
      pickerOptions: {
        shortcuts: [{
          text: 'Última semana',
          onClick (picker) {
            const end = new Date()
            const start = UMA_SEMANA
            picker.$emit('pick', [start, end])
          }
        }, {
          text: 'Último mês',
          onClick (picker) {
            const end = new Date()
            const start = UM_MES
            picker.$emit('pick', [start, end])
          }
        }, {
          text: 'Últimos 3 meses',
          onClick (picker) {
            const end = new Date()
            const start = TRES_MESES
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },

  methods: {
    ...mapActions({
      getAllTiposDocumento: 'tipoDocumentoAssinatura/getTiposDocumento',
      getAllResponsaveis: 'responsavel/getResponsaveis'
    }),

    getTiposDocumento: async function () {
      this.documentoList = await this.getAllTiposDocumento()
    },

    getResponsaveis: async function () {
      this.responsavelList = await this.getAllResponsaveis()
    },

    whitespace (field) {
      if (this.filtro[field]) {
        this.filtro[field] = this.filtro[field].trim()
      }
    }
  },

  mounted: function () {
    this.getTiposDocumento()
    this.getResponsaveis()
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/styles/_variables.scss";

.container {
  display: flex;
  flex-direction: row;
  padding: 5px;
}

.container-input {
  margin-right: 20px;
  margin-top: 0px;
  margin-bottom: 10px;
}

.select {
  width: 100%;
}
.el-date-editor--daterange.el-input__inner {
  width: 96%;
}
.el-date-editor >>> .el-range-separator {
  width: 20%;
}

.el-date-editor >>> .el-picker-panel__body {
  margin-left: 130px;
}

.el-date-editor
  >>> .el-picker-panel__body-wrapper
  >>> .el-picker-panel__sidebar {
  width: 130px;
}
</style>



// WEBPACK FOOTER //
// src/screens/assinatura/components/PesquisaAvancadaDocumentos.vue